import { getObjectInfo } from '../../selectors/objectInfo';
import { TThunkAction } from '../../types/redux';
import { setAnswers } from '../answers';
import { fetchQuestions } from '../../services/questions';
import { setLoading, setQuestions } from './actions';
import { getActiveSortValue } from '../../selectors/sort';
import { prepareQuestionSortRequest } from '../../mappers/prepareQuestionSort';

interface ILoadQuestions {
  page?: number;
  getAllItems?: boolean;
}

export function loadQuestions(props: ILoadQuestions | void): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const { logger, httpApi } = context;
    const state = getState();

    const { objectId } = getObjectInfo(state);
    const sort = getActiveSortValue(state);

    dispatch(setLoading(true));
    try {
      const { answers, questions, hasMore, page } = await fetchQuestions({
        httpApi,
        parameters: {
          newbuildingId: objectId,
          page: props?.page,
          getAllItems: props?.getAllItems,
          sort: prepareQuestionSortRequest(sort),
        },
      });

      dispatch(setAnswers(answers));
      dispatch(
        setQuestions({
          ...questions,
          hasMore,
          page: page || 0,
        }),
      );
    } catch (error) {
      logger.error(error, {
        domain: 'questions#loadQuestions',
        message: error.message,
      });
    }

    dispatch(setLoading(false));
  };
}
